window.Eurus = window.Eurus || {};
window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();
// only register once per page
if (!window.Eurus.loadedScript.has('product-kb-tab.js')) {
  window.Eurus.loadedScript.add('product-kb-tab.js');

  // Tabs (event delegation)
  function attachTabs(rootEl) {
    // Support multiple tab groups
    const tabRoots = rootEl.querySelectorAll('[data-kb-tabs]');
    tabRoots.forEach((tabs) => {
      if (tabs.__kbTabsBound) return;       // idempotent
      tabs.__kbTabsBound = true;

      tabs.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-kb-tab]');
        if (!btn || !tabs.contains(btn)) return;

        const target = btn.getAttribute('data-kb-tab');

        // Query live nodes each click - handles dynamic DOM
        const buttons = tabs.querySelectorAll('[data-kb-tab]');
        const panels  = tabs.querySelectorAll('[data-kb-panel]');

        buttons.forEach((b) => {
          b.classList.toggle('kb-active', b === btn);
        });
        panels.forEach((p) => {
          const match = p.getAttribute('data-kb-panel') === target;
          p.classList.toggle('kb-active', match);
        });
      });
    });
  }

  // Media expandable
  function initMediaExpandable(rootEl) {
    const nodes = rootEl.querySelectorAll('.media-expandable');
    nodes.forEach((wrap) => {
      if (wrap.__kbExpandableBound) return;
      wrap.__kbExpandableBound = true;

      const viewport = wrap.querySelector('.media-expandable__viewport');
      const btn = wrap.querySelector('.media-expandable__toggle');
      if (!viewport || !btn) return;

      const collapsed = Number(wrap.dataset.collapsedHeight || 0);
      if (collapsed > 0) wrap.style.setProperty('--collapsed', collapsed + 'px');

      function overflowing() {
        return viewport.scrollHeight > viewport.clientHeight + 1;
      }
      function updateButton() {
        if (!wrap.classList.contains('is-expanded') && overflowing()) btn.hidden = false;
        else if (!wrap.classList.contains('is-expanded')) btn.hidden = true;

        wrap.classList.toggle('is-overflowing', !wrap.classList.contains('is-expanded') && overflowing())
      }
      function expand() {
        wrap.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = 'View less';

        wrap.classList.remove('is-overflowing')
      }
      function collapse() {
        wrap.classList.remove('is-expanded');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'View more';
      }

      btn.addEventListener('click', () => {
        if (wrap.classList.contains('is-expanded')) {
          collapse();
          requestAnimationFrame(updateButton);
        } else {
          expand();
        }
      });

      // Initial state
      collapse();

      // Wait for media load to compute overflow
      const media = viewport.querySelector('img,video');
      if (media) {
        if (media.tagName === 'VIDEO') {
          media.addEventListener('loadedmetadata', updateButton, { once: true });
          media.addEventListener('loadeddata', updateButton, { once: true });
        } else {
          if (media.complete) updateButton();
          else {
            media.addEventListener('load', updateButton, { once: true });
            media.addEventListener('error', updateButton, { once: true });
          }
        }
      } else {
        updateButton();
      }

      // Resize watchers
      let t;
      window.addEventListener('resize', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          if (!wrap.classList.contains('is-expanded')) updateButton();
        }, 120);
      });

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => {
          if (!wrap.classList.contains('is-expanded')) updateButton();
        });
        ro.observe(viewport);
      }
    });
  }

  //Bootstrap on load and Shopify events
  function init(scope = document) {
    attachTabs(scope);
    initMediaExpandable(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Important for AJAX section reloads & Theme Editor
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => init(e.target));
  document.addEventListener('shopify:section:reorder', (e) => init(e.target));
}



